import _jsx2 from '@babel/runtime/helpers/esm/jsx';
import { ThemeProvider } from 'styled-components';
import '@dbh/lodash-extra';
import TextWithIcon, { themeWithNoIconMargin } from '@dbh/text-with-icon';
export { iconPositionValues } from '@dbh/text-with-icon';
import '@dbh/text';
import { jsx } from 'react/jsx-runtime';

const setIconMargin=themeWithNoIconMargin(),Icon=a=>/*#__PURE__*/_jsx2(ThemeProvider,{theme:setIconMargin},void 0,/*#__PURE__*/jsx(TextWithIcon,{...a}));// We define a component the passes through all the props to `TextWithIcon`
Icon.displayName="Icon";

export { Icon as default };
